<!--应收单-->
<template>
  <div class="app-application">
    <el-card class="box-card">
      <div class="content-title">
        <span class="title-icon"></span>
        <span class="title-details">基本信息</span>
      </div>
      <div>
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :showBtn="false"
          :showSaveBtn="false"
          :disabled="!isEdit"
          @cancelForm="cancel"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import "@/components/dynamic-form";
import { getReceivable } from "@/api/bill/receipt";
import { getDocumentCode } from "@/views/utils";
import initDict from "@/mixin/initDict";

export default {
  name: "ReceivableForm",
  mixins: [initDict],
  data() {
    return {
      id: "",
      form: { contractId: "" },
      isEdit: false,
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            label: "单据编号",
            value: "",
            span: 8,
            disabled: true
          },
          {
            label: "合同编号",
            key: "contractCode",
            type: "input",
            placeholder: "请选择项目",
            span: 8,
          },
          {
            label: "经营人",
            key: "personManage",
            type: "input",
            placeholder: "请选择项目",
            span: 8,
          },
          {
            label: "日期",
            key: "contractDate",
            type: "input",
            disabled: true,
            span: 8,
          },
          {
            label: "签约客户",
            key: "customerSigning",
            span: 8,
            type: "input",
            disabled: true,
          },
          {
            key: "totals",
            label: "应收金额",
            span: 8,
            type: "input",
            disabled: true,
          },
          {
            type: "select",
            key: "moneyId",
            label: "款项说明",
            span: 8,
            options: []
          },
          {
            type: "textarea",
            key: "remark",
            label: "备注",
            disabled: false,
            value: "",
            placeholder: "请输入备注",
            span: 16,
             maxlength: 200,
          }
        ]
      },
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.isEdit = Boolean(Number(this.$route.query.isEdit));
    console.log(this.isEdit)
    if (this.id) {
      getReceivable(this.id).then(res => { // 详情
          const form = res.data;
          form.contractCode = form.paymentDetails.contract.code;
          form.personManage = form.paymentDetails.contract.personManage.name;
          form.customerSigning = form.paymentDetails.contract.customerSigning.name;
          form.contractDate = form.paymentDetails.contract.created;
          form.remark = form.paymentDetails.remark
          this.form = form;
      });
    } else {
      this.form.code = getDocumentCode("YSD");
    }
    // 收款方式
    this.getDict("RECEIPT").then(res => {
      this.formConfig.formItemList[6].options = res.data;
    });
  },
  watch: {},
  methods: {
    cancel() {
      this.$router.go(-1);
    },
  }
};
</script>

<style lang="scss" scoped>
.content-title {
  height: 40px;
  background-color: #e7eff6;
  padding-left: 20px;
  overflow: hidden;
  .title-icon {
    display: inline-block;
    margin-top: 8px;
    width: 4px;
    height: 24px;
    background-color: #1369a8;
    margin-right: 14px;
  }
  .title-details {
    overflow: hidden;
    line-height: 20px;
    display: inline-block;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    font-family: SourceHanSansSC-regular;
  }
}
.el-icon-back {
  padding-bottom: 10px;
}
.button {
      padding-top: 20px;
      text-align: right;
      .btn-submit {
        width: 80px;
        height: 38px;
        background: #1369a8;
        color: white;
      }
      .btn-cancel {
        width: 80px;
        height: 38px;
        background: #fff;
      }
    }
</style>
